import { render, staticRenderFns } from "./crossfilterdc-page.vue?vue&type=template&id=40b0e704&"
import script from "./crossfilterdc-page.vue?vue&type=script&lang=js&"
export * from "./crossfilterdc-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports